export const CLIENT_DATA_KEY = 'clientData';

export interface ClientData {
  firstName: string;
  lastName: string;
  residentName: string;
  email: string;
  phone: string;
  zip: string;
  state: string;
  city: string;
  address: string;
  lookingFor: string;
  budgetRange: string;
  care: string;
  moveTimeline: string;
  affiliateId: string;
}

export const getClientData = (): ClientData | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const clientData = localStorage.getItem(CLIENT_DATA_KEY);
  return clientData ? JSON.parse(clientData) : null;
};

export const setClientData = (clientData: ClientData) => {
  localStorage.setItem(CLIENT_DATA_KEY, JSON.stringify(clientData));
};

// https://www.seniorly.dev/partners/homethrive?data=7975d5cb84dba51897c9ea813978680d%3A57c9687ccb049b9552813b0e57430d324968251d12f2c238383289e6eec79b877a40722bcbc99af49aecd33336ce93792305d6ec031d25529e9646b49e6b3931bfe5a88585dda89ceeadb923ba83cd9ce666d31b6b1bbeb3a9f7461cdabc19807fb1832364f7003cbbc19b9025c85b519456ff0ad777db2032fd9104a87a799d7c94cc2caa33af16207c7a7825599f72aeb75686d5a61f3aa278a32969427aabccc99b7e48497101e5db9fb57985026ed28d0271275e08cd8c8b921d6f51e0ad2487837f4be2b632f6ebaf5971cf7e6683fae88259b2d3259891dd0add1a0bdd56a766063552e6d5852aba4df2d91150d543a85054bff312c0a5aa40397baa66a89f768b9d4948e9a498c57ab7d7a565511b7292b7522bc205974a3fb51e7b39a9e49ab8fd4b9f79d3d623f0e3d3ac69
